import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Row } from '@fs/zion-ui'

export default function EditDanglingFieldFooter({ saving = false, goBackToEditEventsPanel }) {
  const [t] = useTranslation()

  return (
    <Row alignX="end" gutters="md">
      <Button
        data-testid="edit-dangling-field-back-button"
        emphasis="low"
        disabled={saving}
        onClick={() => {
          goBackToEditEventsPanel()
        }}
      >
        {t('edit-dangling-field-footer.cancel', 'Cancel')}
      </Button>
      <Button
        data-testid="edit-dangling-field-save-button"
        emphasis="high"
        disabled={saving}
        form="edit-dangling-field"
        type="submit"
      >
        {t('edit-dangling-field-footer.save', 'Save')}
      </Button>
    </Row>
  )
}
